import {hitAlgolytics} from "@pg-mono/algolytics";

import {getTrackedSiteData} from "./tracked_utils/tracked_site";

export const nativeOfferClickHit = (url: string) => {
    const adDomain = new URL(url).searchParams.get("pgDomain");
    const adHostname = adDomain !== null ? new URL(adDomain).hostname : "";
    if (!adHostname) {
        return;
    }

    const payload = {
        view_type: "offer_list",
        ...getTrackedSiteData()
    };
    const eventName = adHostname.includes("rynekpierwotny") ? "native_offer_internal" : "native_offer_external";

    hitAlgolytics(eventName, payload);
};
